"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultDeliveredReport = {
    totalDelivered: null,
    notificationCenterAttempted: null,
    notificationCenterDelivered: null,
    notificationCenterUniqueDelivered: null,
    notificationCenterUnreachable: null,
    notificationCenterInvalid: null,
    pushAttempted: null,
    pushDelivered: null,
    pushUniqueDelivered: null,
    pushUnreachable: null,
    pushInvalid: null,
};
const defaultOpenedReport = {
    total: null,
    unique: null,
    notificationCenterTotal: null,
    notificationCenterUnique: null,
    pushDirectTotal: null,
    pushDirectUnique: null,
    pushInfluencedTotal: null,
    pushInfluencedUnique: null,
};
exports.default = (state = {
    notificationDeliveredReport: defaultDeliveredReport,
    notificationOpenedReport: defaultOpenedReport,
}, action) => {
    if (action.campaignReport) {
        return {
            notificationDeliveredReport: action.campaignReport.notificationDeliveredReport
                ? action.campaignReport.notificationDeliveredReport
                : state.notificationDeliveredReport,
            notificationOpenedReport: action.campaignReport.notificationOpenedReport
                ? action.campaignReport.notificationOpenedReport
                : state.notificationOpenedReport,
        };
    }
    return state;
};
exports.getCampaignReport = (state) => state.campaignReport;
